import { render, staticRenderFns } from "./fccEmulados.vue?vue&type=template&id=5f9acdfa"
import script from "./fccEmulados.vue?vue&type=script&lang=js"
export * from "./fccEmulados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports